import gql from 'graphql-tag';
import { PROJECT_BANK_ATTACHMENT_SELECTION } from './projectBankAttachmentSelection';

/**
 * Data of the block project-bank-summary ("Zusammenfassung", tab Bank): the bank ZIP and its build
 * state. Read through `Project.blocks.bankSummary`, which checks the block's read permission.
 */
export const PROJECT_BANK_SUMMARY_FIELDS = gql`
  fragment projectBankSummaryFields on ProjectBankSummaryBlock {
    id
    number
    bank {
      ${PROJECT_BANK_ATTACHMENT_SELECTION}
    }
    attachmentBuildStates {
      attachmentType
      state
    }
  }
`;
